import { useDispatch, useSelector } from "react-redux";
import { fieldsToCheckFeeSimple } from "../../../data/permitFormsData";
import FinancialBPModal from "../FinancialBPModal";
import React from "react";
import { setBuildingState } from "../../../store/actions/permitFormActions/buildingStateActions";

const AddingNewFeeSimpleModal = () => {
  const { addingNewFeeSimple } = useSelector((state) => state.buildingState);

  const dispatch = useDispatch();

  return (
    <FinancialBPModal
      type="feeSimple"
      open={addingNewFeeSimple}
      title={"Add New Fee Simple Titleholder"}
      handleStateNo={() => {
        dispatch(setBuildingState({ addingNewFeeSimple: false }));
      }}
      fieldsToCheck={fieldsToCheckFeeSimple}
    />
  );
};

export default React.memo(AddingNewFeeSimpleModal);
